export const SAVE_SOLO = "SAVE_SOLO";
export const SELECTED_SOLO = "SELECTED_SOLO";
export const SOLO_SAVE_SUCCESS = "SOLO_SAVE_SUCCESS"
export const SOLO_SERVICE = "SOLO_SERVICE"
export const NODES_CONNECTABLE = "SOLO_CONNECTABLE"
export const EVENTS_NODE_CONNECTION = "EVENTS_NODE_CONNECTION"
export const MODAL_SELECTED_VALUE = "MODAL_SELECTED_VALUE"
export const SELECTED_JOURNEY = "SELECTED_JOURNEY"
export const GO_BACK = "GO_BACK"
export const SOURCE_CONNECTED = "SOURCE_CONNECTED"
export const GO_BACK_TO_SOLO_FLOW= "GO_BACK_TO_SOLO_FLOW"

export interface DataSolo { }

interface SoloAction {
  type: typeof EVENTS_NODE_CONNECTION | typeof SOURCE_CONNECTED | typeof GO_BACK | typeof SELECTED_JOURNEY | typeof SAVE_SOLO | typeof MODAL_SELECTED_VALUE | typeof SELECTED_SOLO | typeof SOLO_SAVE_SUCCESS | typeof SOLO_SERVICE | typeof NODES_CONNECTABLE | typeof GO_BACK_TO_SOLO_FLOW;
  data: any;
}

export type SoloActionType = SoloAction;
